export const OVERLAYS = <const>{
  TOOLTIP: "tooltip-overlay-container",
  SNACKBAR: "snackbar-overlay-container",
};
